import styled from '@emotion/styled';

export const FieldRow = styled.div`
  display: flex;
  width: 100%;
`;
